class RecognitionComponent extends HTMLElement {
  constructor() {
    super();
    this.handleMouseover = this.handleMouseover.bind(this);
    this.handleMouseleave = this.handleMouseleave.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
    this.currentIndex = 0;
    this.interval = null;
  }

  connectedCallback() {
    this.recognitionImages = this.querySelectorAll(".recoginition-image");
    this.recognitionTexts = this.querySelectorAll(".recoginition-text");
    this.recognitionDots = this.querySelectorAll(".recognition-dot");

    this.recognitionImages.forEach((image) => {
      image.addEventListener("mouseenter", this.handleMouseover);
      image.addEventListener("mouseleave", this.handleMouseleave);
    });

    this.observer = new IntersectionObserver(this.handleIntersection, {
      threshold: 0.5
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.recognitionImages.forEach((image) => {
      image.removeEventListener("mouseenter", this.handleMouseover);
      image.removeEventListener("mouseleave", this.handleMouseleave);
    });
    if (this.observer) this.observer.disconnect();
    this.clearAutoCycle();
  }

  handleMouseover(event) {
    if (window.innerWidth <= 749) return;

    const imgClosest = event.target.closest(".recoginition-image");
    if (!imgClosest) return;
    const imageId = imgClosest.getAttribute("data-image-id");

    this.activateById(imageId);

    this.currentIndex = [...this.recognitionImages].findIndex(img =>
      img.getAttribute("data-image-id") === imageId
    );

    this.clearAutoCycle();  // pause auto cycle while hovered
  }

  handleMouseleave(event) {
    if (window.innerWidth <= 749) return;

    this.startAutoCycle();  // resume auto cycle immediately on mouse leave
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && window.innerWidth > 749) {
        this.startAutoCycle();
      } else {
        this.clearAutoCycle();
      }
    });
  }

  startAutoCycle() {
    this.clearAutoCycle();
    this.highlightImage(this.currentIndex);
    this.interval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.recognitionImages.length;
      this.highlightImage(this.currentIndex);
    }, 3000);
  }

  clearAutoCycle() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  highlightImage(index) {
    const image = this.recognitionImages[index];
    if (!image) return;
    const imageId = image.getAttribute("data-image-id");
    this.activateById(imageId);
  }

  activateById(imageId) {
    this.recognitionTexts.forEach(text => text.classList.remove("is--active"));
    this.recognitionDots.forEach(dot => dot.classList.remove("is--active"));
    this.recognitionImages.forEach(img => img.classList.remove("is--scaled"));

    const activeText = this.querySelector(`.recoginition-text.${imageId}`);
    const activeDot = this.querySelector(`.recognition-dot.${imageId}`);
    const activeImage = this.querySelector(`.recoginition-image[data-image-id="${imageId}"]`);

    if (activeText) activeText.classList.add("is--active");
    if (activeDot) activeDot.classList.add("is--active");
    if (activeImage) activeImage.classList.add("is--scaled");
  }
}

customElements.define("recognition-component", RecognitionComponent);
